import type { AddPermitTypeFormInputs } from '@src/permitTypesManager/AddPermitTypeFormInputs';
import { PermitTypeAssembler } from '@src/permitTypesManager/PermitTypeAssembler';
import type { PermitTypeFields } from '@src/permitTypesManager/PermitTypeFields';
import { CustomDocumentPdfFields } from '@src/permitTypesManager/permitTypeSections/CustomDocumentPdfFields';
import { PermitTypeClient } from '@src/permitTypesManager/services/PermitTypeClient';
import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

export const useEditPermitType = ({
  permitTypeId,
  onSuccess,
  onError,
  onAlreadyExistsError,
}: {
  permitTypeId: string;
  onSuccess: () => void;
  onError: () => void;
  onAlreadyExistsError: () => void;
}) => {
  const { mutate } = useMutation({
    mutationFn: async (data: AddPermitTypeFormInputs) => {
      const definition = PermitTypeAssembler.toDTO(data as PermitTypeFields);
      await PermitTypeClient.editType(
        permitTypeId,
        definition,
        data[CustomDocumentPdfFields.fieldName],
      );
    },
    onSuccess,
    onError: (error: AxiosError) => {
      const status = error?.response?.status;
      if (status === 409) {
        onAlreadyExistsError();
      } else {
        onError();
      }
    },
  });
  return {
    editPermitType: mutate,
  };
};
